// Custom global scripts
jQuery(document).ready(
  (function ($) {
    "use strict";

    // Foundation Init
    $(document).foundation();

    //bookmark save
    $(".bookmark-save").click(function (e) {
      if (window.sidebar && window.sidebar.addPanel) {
        // Firefox <23

        window.sidebar.addPanel(document.title, window.location.href, "");
      } else if (window.external && "AddFavorite" in window.external) {
        // Internet Explorer

        window.external.AddFavorite(location.href, document.title);
      } else if (
        (window.opera && window.print) ||
        (window.sidebar && !(window.sidebar instanceof Node))
      ) {
        // Opera <15 and Firefox >23
        /**
         * For Firefox <23 and Opera <15, no need for JS to add to bookmarks
         * The only thing needed is a `title` and a `rel="sidebar"`
         * To ensure that the bookmarked URL doesn't have a complementary `#` from our trigger's href
         * we force the current URL
         */
        triggerBookmark
          .attr("rel", "sidebar")
          .attr("title", document.title)
          .attr("href", window.location.href);
        return true;
      } else {
        // For the other browsers (mainly WebKit) we use a simple alert to inform users that they can add to bookmarks with ctrl+D/cmd+D

        alert(
          "You can add this page to your bookmarks by pressing " +
            (navigator.userAgent.toLowerCase().indexOf("mac") != -1
              ? "Command/Cmd"
              : "CTRL") +
            " + D on your keyboard."
        );
      }
      // If you have something in the `href` of your trigger
      return false;
    });

    //Search home hero
    $("#switch").click(function () {
      if ($(this).prop("checked") == true) {
        console.log("Checkbox is checked. Show rent listing search.");
        $("#switch-form").attr("value", "rent");
      } else if ($(this).prop("checked") == false) {
        console.log("Checkbox is unchecked.  Show buy listing search.");
        //change to 'buy listing'
        $("#switch-form").attr("value", "buy");
      }
    });

    $(window).on("scroll", function () {
      if ($(window).scrollTop() > 50) {
        $(".site-header").addClass("active");
      } else {
        $(".site-header").removeClass("active");
      }
    });

    // SLIDER
    var tesmonialsFull = new Swiper("#tesmonials-full", {
      loop: true,
      speed: 3000,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      autoplay: {
        delay: 14000,
        disableOnInteraction: false,
      },
      slidesPerView: 1,
    });

    var testimonials = new Swiper("#testimonials", {
      loop: true,
      speed: 3000,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      autoplay: {
        delay: 14000,
        disableOnInteraction: false,
      },
      slidesPerView: 1,
      spaceBetween: 2,
      breakpoints: {
        1024: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
      },
    });

    var postsSlider = new Swiper("#posts-slider", {
      loop: true,
      speed: 5000,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
      },
      slidesPerView: 1,
      spaceBetween: 2,
      breakpoints: {
        1280: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
      },
    });

    var relatedPostsSlider = new Swiper("#related-posts-slider", {
      loop: true,
      speed: 5000,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
      },
      slidesPerView: 1,
      spaceBetween: 10,
      breakpoints: {
        1920: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    });

    var listingSlider = new Swiper("#listing-slider", {
      // loop: true,
      speed: 5000,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
      },
      slidesPerView: 1,
      spaceBetween: 2,
      breakpoints: {
        1900: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    });

    if ($("#announcementModal").length) {
      setTimeout(function () {
        $("#announcementModal").foundation("open");
      }, 2000);
    }


  })(jQuery)
);


